import React from 'react';
import styles from './UploadStatusIndicator.module.scss';

interface UploadStatusIndicatorProps {
  status: 'idle' | 'uploading' | 'success' | 'failed';
  onRetry?: () => void;
  error?: string;
}

const UploadStatusIndicator: React.FC<UploadStatusIndicatorProps> = ({
  status,
  onRetry,
  error,
}) => {
  if (status === 'uploading') return <span className={styles.uploading}>Uploading...</span>;
  if (status === 'success') return <span className={styles.success}>✔ Uploaded</span>;
  if (status === 'failed')
    return (
      <span className={styles.failed}>
        ✖ Failed{error ? `: ${error}` : ''}
        {onRetry && (
          <button className={styles.retryBtn} onClick={onRetry} type="button">
            Retry
          </button>
        )}
      </span>
    );
  return null;
};

export default UploadStatusIndicator;
